import { jsx as _jsx } from "react/jsx-runtime";
import { useState, useMemo } from 'react';
import { OryProvider } from '../core/ory/ory-context';
import { useAuthFlow } from '../features/login-flow/hooks/useLoginFlow';
import { LoginCard } from '../features/login-flow/components/LoginCard';
function LoginPageContent({ theme }) {
    const { state, submitEmail, selectMethod, submitCode, clearError } = useAuthFlow();
    // Get pre-filled email and error from URL params (e.g., from failed invite flow)
    const params = useMemo(() => new URLSearchParams(window.location.search), []);
    const initialEmail = params.get('email') || '';
    const urlError = params.get('error');
    const [urlErrorDismissed, setUrlErrorDismissed] = useState(false);
    // Show URL error initially (if not dismissed), then state.error takes over
    const displayError = state.error || (urlErrorDismissed ? null : urlError);
    const handleClearError = () => {
        setUrlErrorDismissed(true);
        clearError();
    };
    const handleEmailSubmit = async (email, remember) => {
        await submitEmail(email, remember);
    };
    const handleMethodSelect = async (method, email, rememberMe) => {
        if (method === 'code' && email) {
            await selectMethod('code', email, rememberMe);
        }
        else if (method === 'passkey') {
            await selectMethod('passkey', undefined, rememberMe);
        }
        else {
            await selectMethod(method, undefined, rememberMe);
        }
    };
    const handleVerifyOTP = async (code, rememberMe) => {
        if (submitCode) {
            await submitCode(code, rememberMe);
        }
    };
    return (_jsx("main", { className: "auth-page-main", style: {
            flex: 1,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
        }, children: _jsx(LoginCard, { onSubmit: handleEmailSubmit, onSelectMethod: handleMethodSelect, onVerifyOTP: handleVerifyOTP, onClearError: handleClearError, error: displayError, initialEmail: initialEmail }) }));
}
export function LoginPage({ theme, onThemeToggle }) {
    return (_jsx(OryProvider, { children: _jsx("div", { style: {
                minHeight: '100vh',
                display: 'flex',
                flexDirection: 'column'
            }, children: _jsx(LoginPageContent, { theme: theme }) }) }));
}
